import {API_BASE_URL} from '../config/apiConfig';

interface ModulesResult {
    success: boolean;
    modules?: any;
    error?: string;
}

export interface Brand {
    id: string;
    name: string;
    status: string;
}

interface BrandResult {
    success: boolean;
    brand?: Brand;
    error?: string;
}

export const getBrand = async (token: string, lang?: string): Promise<BrandResult> => {
    try {
        const url = lang
            ? `${API_BASE_URL}/api/getBrand?lang=${encodeURIComponent(lang)}`
            : `${API_BASE_URL}/api/getBrand`;
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.message || 'Failed to fetch brand');
        }

        const data = await response.json();
        return {
            success: true,
            brand: data,
        };
    } catch (error) {
        return {
            success: false,
            error: error instanceof Error ? error.message : 'Network error occurred',
        };
    }
};

export const getModules = async (token: string, lang?: string): Promise<ModulesResult> => {
    try {
        const url = lang
            ? `${API_BASE_URL}/api/getModules?lang=${encodeURIComponent(lang)}`
            : `${API_BASE_URL}/api/getModules`;
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.message || 'Failed to fetch modules');
        }

        const data = await response.json();
        return {
            success: true,
            modules: data,
        };
    } catch (error) {
        return {
            success: false,
            error: error instanceof Error ? error.message : 'Network error occurred',
        };
    }
};
